// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"76":"manage-desk","296":"electronic-file","425":"construction-data"}[chunkId] + "." + {"76":"089c60b8","296":"6ef36157","425":"b561934e"}[chunkId] + ".js";
};